const DOMAIN_NAME_PREFIX = 'tipps.'

export { DOMAIN_NAME_PREFIX }
export default DOMAIN_NAME_PREFIX
